<template>
  <div class="infotext" :class="context">
    <i class="infotext__icon" v-b-modal="`modal-${id}`">
      <svg
        width="20px"
        height="20px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g
          id="icons-/-info-copy"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <path
            d="M12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 Z M12,20 C16.418278,20 20,16.418278 20,12 C20,7.581722 16.418278,4 12,4 C7.581722,4 4,7.581722 4,12 C4,16.418278 7.581722,20 12,20 Z M12,11 C12.5522847,11 13,11.4477153 13,12 L13,16 C13,16.5522847 12.5522847,17 12,17 C11.4477153,17 11,16.5522847 11,16 L11,12 C11,11.4477153 11.4477153,11 12,11 Z M12,7 C12.5522847,7 13,7.44771525 13,8 C13,8.55228475 12.5522847,9 12,9 C11.4477153,9 11,8.55228475 11,8 C11,7.44771525 11.4477153,7 12,7 Z"
            id="Combined-Shape"
            :fill="fillColor"
          />
        </g>
      </svg>
    </i>
    <b-modal :id="`modal-${id}`" :title="content.title" centered hide-footer>
      <div v-if="formatHtml">
        <div v-html="content.text"></div>
      </div>
      <div v-else>
        <p class="mt-3 mb-0">{{ content.text }}</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
  export default {
    props: {
      id: {
        type: String,
        required: true,
      },
      content: {
        title: String,
        text: {
          type: String,
          required: true,
        },
      },
      context: {
        type: String,
        required: false,
        default: 'input',
      },
      fillColor: {
        type: String,
        required: false,
        default: '#668C9F',
      },
      formatHtml: {
        type: Boolean,
        required: false,
      },
    },
  };
</script>
<style lang="scss" scoped>
  /* Overwrite bootstrap modal */
  .infotext {
    position: absolute;
    right: 0;
    top: 3px;
    z-index: 2;

    &.textarea {
      top: -4px;
    }

    &__icon {
      cursor: pointer;
    }
  }
</style>

<style lang="scss">
  /* Overwrite bootstrap modal */
  /* purgecss start ignore */
  .modal {
    color: $black;

    &-header {
      h5 {
        font-size: 28px;
        line-height: 34px;
        font-weight: normal;
        margin-top: 10px;
      }

      .close {
        color: $blue60;
        font-size: 2.5rem;
        font-weight: normal;
        opacity: 1;
        outline: 0;
        line-height: 24px;
        z-index: 1;
      }
    }

    &-body {
      line-height: 22px;
    }
  }
  /* purgecss end ignore */
</style>
